import React from 'react';
import { Button } from '@components/ui/buttons/Button';

/**
 * Confirmation modal for POIs - Yes, No, and optional third button (usually Cancel)
 * 
 * @param {Boolean} showModal
 * @param {string} message
 * @param {Function} handleConfirm
 * @param {Function} handleNo
 * @param {Function | null} handleThirdOption
 * @param {string} confirmButtonText
 * @param {string} noButtonText
 * @param {string | null} thirdOptionText
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const ConfirmPoiSave = ({
    showModal, 
    message, 
    handleConfirm, 
    handleNo,
    handleThirdOption = null,
    confirmButtonText,
    noButtonText,
    thirdOptionText = null
}) => {
    if(!showModal) return null

    return (
        <>

            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-8 rounded-lg max-w-md mx-4 flex flex-col items-center">
                    <p className="text-md text-center">{message}</p>

                    <div className="mt-6 flex flex-col">
                        
                        <div className='flex max-[450px]:flex-col flex-row'>
                            <Button variant="success" onClick={handleConfirm} className='m-2'>{confirmButtonText || "Yes"}</Button>
                            <Button variant="danger" onClick={handleNo} className='m-2'>{noButtonText || "No"}</Button>
                        </div>
                        

                        {(thirdOptionText && handleThirdOption) && <Button variant="cancel" onClick={handleThirdOption} className='mt-2 mr-2 self-end'>{thirdOptionText || "Cancel"}</Button>}
                    </div>
                </div>
            </div>

        </>
    )    
}

